module.exports = __webpack_public_path__ + "images/8642157c873587470eb15a272e74a4b5.jpg";